import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-ffe91f70")
const _hoisted_1 = { class: "card-footer px-9" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h2 class=\"mo-accordion-header\" data-v-ffe91f70><button class=\"accordion-button collapsed cursor-pointer\" type=\"button\" data-v-ffe91f70><div class=\"d-flex flex-row align-items-center\" data-v-ffe91f70><div class=\"me-3 svg-icon svg-icon-2x\" data-v-ffe91f70><div class=\"checkmark-imitation\" data-v-ffe91f70></div></div></div><div class=\"title-imitation\" data-v-ffe91f70></div></button></h2>", 1)
const _hoisted_3 = [
  _hoisted_2
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
      return _createElementVNode("div", {
        key: index,
        class: "accordion-item"
      }, _hoisted_3)
    }), 64))
  ]))
}